import React from 'react'
import PropTypes from 'prop-types'
import BasicTable from '../../../../../../atoms/BasicTable'

function TablesDisplay ({ tables }) {
  if (!tables || tables.length === 0) return null

  return (
    <div style={{ marginBottom: '16px' }}>
      <h4>Tables ({tables.length})</h4>
      <BasicTable className='opal-presentation-table zebra-rows'>
        <thead className='opt-thead'>
          <tr className='opt-tr'>
            <th className='opt-th'>Table Code</th>
            <th className='opt-th'>Schema</th>
            <th className='opt-th'>Alias</th>
            <th className='opt-th'>Purpose</th>
          </tr>
        </thead>
        <tbody className='opt-tbody'>
          {tables.map((table, idx) => (
            <tr className='opt-tr' key={idx}>
              <td className='opt-td'>{table.tableCode}</td>
              <td className='opt-td'>{table.schema || '-'}</td>
              <td className='opt-td'>{table.alias}</td>
              <td className='opt-td'>{table.purpose}</td>
            </tr>
          ))}
        </tbody>
      </BasicTable>
    </div>
  )
}

TablesDisplay.propTypes = {
  tables: PropTypes.array.isRequired
}

export default TablesDisplay
